import * as React from "react";
import { GoldCoin } from "../Toolbar/GoldCoin";
import { SilverCoin } from "../Toolbar/SilverCoin";

export const Coins = ({
  amount,
  spaced,
}: {
  amount: number;
  spaced?: boolean;
}) => {
  const gold = Math.floor(amount / 20);
  const silver = amount % 20;

  return (
    <span>
      {gold > 0 && (
        <span className={spaced ? "inline-block w-[50px]" : ""}>
          {gold} <GoldCoin />,{" "}
        </span>
      )}{" "}
      {silver} <SilverCoin />
    </span>
  );
};
